export default __webpack_public_path__ + "static/media/jobs.e5a52d01.svg";